import { gql } from 'graphql.macro';

export const CreateNearMiss = gql`
    mutation createNearMiss($request: NearMissRequestModelInput) {
        createNearMiss(request: $request) {observationId, uniqueRecordId}
    }
`;